module.exports = __webpack_public_path__ + "media/images/company/cp23-89ecc0c8ad0a16dbb00bf227312e632b.png";